"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("../../assets/PPToggle.css");
var PPToggle = function (props) {
    var handleCheck = function () {
        !props.disabled && props.onChange &&
            props.onChange({ name: props.name, checked: !props.toggled });
    };
    return react_1.default.createElement("div", { className: "pp-toggle ".concat(props.toggled ? 'toggled' : ''), onClick: handleCheck },
        react_1.default.createElement("div", { className: "box" },
            react_1.default.createElement("div", { className: "dot" })),
        props.title && react_1.default.createElement("span", { className: "title" }, props.title));
};
exports.default = PPToggle;
